import type { FaireProductEntity } from "../../entity_types/product";

export const plant_dyed_10: FaireProductEntity = {
  token: "plant-dyed-10",
  type: "product",
  name: "Naturally Dyed Silk Scarf",
  brandName: "Oima",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/2dfe5612c6e50540969e2581cd53ecb3b2e0a52d13efa5b054cc78793e948e26.png",
  priceDollars: 34,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/2dfe5612c6e50540969e2581cd53ecb3b2e0a52d13efa5b054cc78793e948e26.png",
  weight: 0.2,
  dimensions: {
    width: 20,
    height: 60,
    depth: 0.5,
  },
  description: "Naturally dyed silk scarf with organic colors",
  categoryTokens: ["cat_accessories"],
  tags: [
    "plant-dyed",
    "natural-dye",
    "sustainable-textiles",
    "silk",
    "scarf",
    "premium",
  ],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
